"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOB = exports.nonNumberRegex = void 0;
exports.nonNumberRegex = /[^0-9]+/g;
var LOB;
(function (LOB) {
    LOB["WIRELESS"] = "WIRELESS";
    LOB["BUSINESS"] = "BUSINESS";
    LOB["FIBER"] = "FIBER";
})(LOB = exports.LOB || (exports.LOB = {}));
//# sourceMappingURL=constants.js.map